import React from 'react'
import { Paper } from '@mui/material'
import Navbar from '../components/common/navbar'
import Footer from '../components/common/footer'



const ResultPage = () => {
    return (
        <>
            <Navbar />
            <div className='my-0'>
                <Paper elevation={3}>
                    <div className='py-5 bg-about'>

                        <div className="text-center">
                            <h2 className='about-header'> Purbanchal Educational Welfare Society (PEWS) </h2>
                        </div>

                    </div>

                    <div className=' p-5'>
                        <div className="text-center">
                            <h2> RESULT </h2>
                        </div>
                        <div className="p-4 ">
                            <div className="row ">
                                result
                                <div className="d-flex justify-content-center text-justify">

                                    <div className="col-md-4 m-2">
                                        <label htmlFor="">Your Enrollment No.</label>
                                        <input type="text" className='form-control' placeholder='Enter Enrollment Number' name="" id="" />
                                    </div>
                                    <div className="col-md-4 m-2">
                                        <label htmlFor="">Your Date of Birt</label>
                                        <input type="text" className='form-control' placeholder='DDMMYYYY' name="" id="" />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </Paper>
            </div>


            <Footer />
        </>
    )
}

export default ResultPage